<template>
  <div class="p-5 space-y-4">
    <ProcedureBased class="space-y-4" />
  </div>
</template>

<script setup lang="ts">
import ProcedureBased from "./ProcedureBased.vue";
</script>
